export * from './ngx-geoautocomplete.module';



// WEBPACK FOOTER //
// ./~/tslint-loader?emitErrors=true&failOnHint=true!./src/index.ts